var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chipview__absolute",style:({
    left:(_vm.param_left + "px"),
    top:(_vm.param_top + "px"),
    transform: ("rotate(" + _vm.rotation + "deg)"),
    width: (_vm.pin_width + "px"),
})},[_c('div',{staticClass:"chipview__pincolumn"},_vm._l((_vm.pins),function(myPin,id){return _c('pin',{key:id,attrs:{"col_id":_vm.col_id,"pin":myPin,"height":_vm.pin_height,"rotation":_vm.rotation}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }